window.printCanvasElement = (elem, canvas) => {
    var dataUrl = document.getElementById(canvas).toDataURL()
    var mywindow = window.open('', 'PRINT', 'height=400,width=600');

    mywindow.document.write('<html><head><title>' + document.title  + '</title>')
    mywindow.document.write('</head><body>')
    mywindow.document.write(document.getElementById(elem).innerHTML)
    if (dataUrl) {
        mywindow.document.write("<br><img src='" + dataUrl + "'/>")
    }
    mywindow.document.write('</body></html>')

    mywindow.document.close() // necessary for IE >= 10
    mywindow.focus() // necessary for IE >= 10*/

    mywindow.print()
    mywindow.close()

    return true;
}
